module.exports = __webpack_public_path__ + "static/media/bird-silky-chicken1.0f4357a2.aac";